// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CountryRouteImport } from './routes/$country'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as BusinessRouteImport } from './routes/business'
import { Route as CalculatorsRouteImport } from './routes/calculators'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CreditCardsRouteImport } from './routes/credit-cards'
import { Route as CrossBorderWealthRouteImport } from './routes/cross-border-wealth'
import { Route as CurrencyHedgingExpats2026RouteImport } from './routes/currency-hedging-expats-2026'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as EditorialProcessRouteImport } from './routes/editorial-process'
import { Route as FinanceRouteImport } from './routes/finance'
import { Route as FreelancerBusinessLoansAbroad2026RouteImport } from './routes/freelancer-business-loans-abroad-2026'
import { Route as HealthcareRouteImport } from './routes/healthcare'
import { Route as HousingLivingCostRouteImport } from './routes/housing-living-cost'
import { Route as ImmigrationRouteImport } from './routes/immigration'
import { Route as ImmigrationLawyerVsDiy2026RouteImport } from './routes/immigration-lawyer-vs-diy-2026'
import { Route as InvestmentMoneyTransferRouteImport } from './routes/investment-money-transfer'
import { Route as JobsRouteImport } from './routes/jobs'
import { Route as LatestRouteImport } from './routes/latest'
import { Route as MediaCreditsRouteImport } from './routes/media-credits'
import { Route as MissionVisionRouteImport } from './routes/mission-vision'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as QuickGuidesRouteImport } from './routes/quick-guides'
import { Route as RemoteWorkRouteImport } from './routes/remote-work'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SuccessStoriesRouteImport } from './routes/success-stories'
import { Route as TaxRouteImport } from './routes/tax'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VisaGuides2026RouteImport } from './routes/visa-guides-2026'
import { Route as AustraliaSlugRouteImport } from './routes/australia.$slug'
import { Route as CanadaSlugRouteImport } from './routes/canada.$slug'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as EventsCountryRouteImport } from './routes/events.$country'
import { Route as ItalySlugRouteImport } from './routes/italy.$slug'
import { Route as PortugalSlugRouteImport } from './routes/portugal.$slug'
import { Route as PostSlugRouteImport } from './routes/post.$slug'
import { Route as TopicsIndexRouteImport } from './routes/topics.index'
import { Route as TripCountryRouteImport } from './routes/trip.$country'
import { Route as UkSlugRouteImport } from './routes/uk.$slug'
import { Route as UsaSlugRouteImport } from './routes/usa.$slug'
import { Route as PortugalArticlesIndexRouteImport } from './routes/portugal.articles.index'
import { Route as TopicsSlugIndexRouteImport } from './routes/topics.$slug.index'
import { Route as TopicsSlugArticleRouteImport } from './routes/topics.$slug.$article'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CountryRoute = CountryRouteImport.update({
            id: '/$country',path: '/$country',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const BusinessRoute = BusinessRouteImport.update({
            id: '/business',path: '/business',getParentRoute: () => rootRouteImport
          })
const CalculatorsRoute = CalculatorsRouteImport.update({
            id: '/calculators',path: '/calculators',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CreditCardsRoute = CreditCardsRouteImport.update({
            id: '/credit-cards',path: '/credit-cards',getParentRoute: () => rootRouteImport
          })
const CrossBorderWealthRoute = CrossBorderWealthRouteImport.update({
            id: '/cross-border-wealth',path: '/cross-border-wealth',getParentRoute: () => rootRouteImport
          })
const CurrencyHedgingExpats2026Route = CurrencyHedgingExpats2026RouteImport.update({
            id: '/currency-hedging-expats-2026',path: '/currency-hedging-expats-2026',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const EditorialProcessRoute = EditorialProcessRouteImport.update({
            id: '/editorial-process',path: '/editorial-process',getParentRoute: () => rootRouteImport
          })
const FinanceRoute = FinanceRouteImport.update({
            id: '/finance',path: '/finance',getParentRoute: () => rootRouteImport
          })
const FreelancerBusinessLoansAbroad2026Route = FreelancerBusinessLoansAbroad2026RouteImport.update({
            id: '/freelancer-business-loans-abroad-2026',path: '/freelancer-business-loans-abroad-2026',getParentRoute: () => rootRouteImport
          })
const HealthcareRoute = HealthcareRouteImport.update({
            id: '/healthcare',path: '/healthcare',getParentRoute: () => rootRouteImport
          })
const HousingLivingCostRoute = HousingLivingCostRouteImport.update({
            id: '/housing-living-cost',path: '/housing-living-cost',getParentRoute: () => rootRouteImport
          })
const ImmigrationRoute = ImmigrationRouteImport.update({
            id: '/immigration',path: '/immigration',getParentRoute: () => rootRouteImport
          })
const ImmigrationLawyerVsDiy2026Route = ImmigrationLawyerVsDiy2026RouteImport.update({
            id: '/immigration-lawyer-vs-diy-2026',path: '/immigration-lawyer-vs-diy-2026',getParentRoute: () => rootRouteImport
          })
const InvestmentMoneyTransferRoute = InvestmentMoneyTransferRouteImport.update({
            id: '/investment-money-transfer',path: '/investment-money-transfer',getParentRoute: () => rootRouteImport
          })
const JobsRoute = JobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => rootRouteImport
          })
const LatestRoute = LatestRouteImport.update({
            id: '/latest',path: '/latest',getParentRoute: () => rootRouteImport
          })
const MediaCreditsRoute = MediaCreditsRouteImport.update({
            id: '/media-credits',path: '/media-credits',getParentRoute: () => rootRouteImport
          })
const MissionVisionRoute = MissionVisionRouteImport.update({
            id: '/mission-vision',path: '/mission-vision',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const QuickGuidesRoute = QuickGuidesRouteImport.update({
            id: '/quick-guides',path: '/quick-guides',getParentRoute: () => rootRouteImport
          })
const RemoteWorkRoute = RemoteWorkRouteImport.update({
            id: '/remote-work',path: '/remote-work',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SuccessStoriesRoute = SuccessStoriesRouteImport.update({
            id: '/success-stories',path: '/success-stories',getParentRoute: () => rootRouteImport
          })
const TaxRoute = TaxRouteImport.update({
            id: '/tax',path: '/tax',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const VisaGuides2026Route = VisaGuides2026RouteImport.update({
            id: '/visa-guides-2026',path: '/visa-guides-2026',getParentRoute: () => rootRouteImport
          })
const AustraliaSlugRoute = AustraliaSlugRouteImport.update({
            id: '/australia/$slug',path: '/australia/$slug',getParentRoute: () => rootRouteImport
          })
const CanadaSlugRoute = CanadaSlugRouteImport.update({
            id: '/canada/$slug',path: '/canada/$slug',getParentRoute: () => rootRouteImport
          })
const EventsIndexRoute = EventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => rootRouteImport
          })
const EventsCountryRoute = EventsCountryRouteImport.update({
            id: '/events/$country',path: '/events/$country',getParentRoute: () => rootRouteImport
          })
const ItalySlugRoute = ItalySlugRouteImport.update({
            id: '/italy/$slug',path: '/italy/$slug',getParentRoute: () => rootRouteImport
          })
const PortugalSlugRoute = PortugalSlugRouteImport.update({
            id: '/portugal/$slug',path: '/portugal/$slug',getParentRoute: () => rootRouteImport
          })
const PostSlugRoute = PostSlugRouteImport.update({
            id: '/post/$slug',path: '/post/$slug',getParentRoute: () => rootRouteImport
          })
const TopicsIndexRoute = TopicsIndexRouteImport.update({
            id: '/topics/',path: '/topics/',getParentRoute: () => rootRouteImport
          })
const TripCountryRoute = TripCountryRouteImport.update({
            id: '/trip/$country',path: '/trip/$country',getParentRoute: () => rootRouteImport
          })
const UkSlugRoute = UkSlugRouteImport.update({
            id: '/uk/$slug',path: '/uk/$slug',getParentRoute: () => rootRouteImport
          })
const UsaSlugRoute = UsaSlugRouteImport.update({
            id: '/usa/$slug',path: '/usa/$slug',getParentRoute: () => rootRouteImport
          })
const PortugalArticlesIndexRoute = PortugalArticlesIndexRouteImport.update({
            id: '/portugal/articles/',path: '/portugal/articles/',getParentRoute: () => rootRouteImport
          })
const TopicsSlugIndexRoute = TopicsSlugIndexRouteImport.update({
            id: '/topics/$slug/',path: '/topics/$slug/',getParentRoute: () => rootRouteImport
          })
const TopicsSlugArticleRoute = TopicsSlugArticleRouteImport.update({
            id: '/topics/$slug/$article',path: '/topics/$slug/$article',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,CountryRoute: CountryRoute,AboutRoute: AboutRoute,AdminRoute: AdminRoute,BusinessRoute: BusinessRoute,CalculatorsRoute: CalculatorsRoute,ContactRoute: ContactRoute,CreditCardsRoute: CreditCardsRoute,CrossBorderWealthRoute: CrossBorderWealthRoute,CurrencyHedgingExpats2026Route: CurrencyHedgingExpats2026Route,DisclaimerRoute: DisclaimerRoute,EditorialProcessRoute: EditorialProcessRoute,FinanceRoute: FinanceRoute,FreelancerBusinessLoansAbroad2026Route: FreelancerBusinessLoansAbroad2026Route,HealthcareRoute: HealthcareRoute,HousingLivingCostRoute: HousingLivingCostRoute,ImmigrationRoute: ImmigrationRoute,ImmigrationLawyerVsDiy2026Route: ImmigrationLawyerVsDiy2026Route,InvestmentMoneyTransferRoute: InvestmentMoneyTransferRoute,JobsRoute: JobsRoute,LatestRoute: LatestRoute,MediaCreditsRoute: MediaCreditsRoute,MissionVisionRoute: MissionVisionRoute,PrivacyRoute: PrivacyRoute,QuickGuidesRoute: QuickGuidesRoute,RemoteWorkRoute: RemoteWorkRoute,SearchRoute: SearchRoute,SuccessStoriesRoute: SuccessStoriesRoute,TaxRoute: TaxRoute,TermsRoute: TermsRoute,VisaGuides2026Route: VisaGuides2026Route,AustraliaSlugRoute: AustraliaSlugRoute,CanadaSlugRoute: CanadaSlugRoute,EventsCountryRoute: EventsCountryRoute,ItalySlugRoute: ItalySlugRoute,PortugalSlugRoute: PortugalSlugRoute,PostSlugRoute: PostSlugRoute,TripCountryRoute: TripCountryRoute,UkSlugRoute: UkSlugRoute,UsaSlugRoute: UsaSlugRoute,EventsIndexRoute: EventsIndexRoute,TopicsIndexRoute: TopicsIndexRoute,TopicsSlugArticleRoute: TopicsSlugArticleRoute,PortugalArticlesIndexRoute: PortugalArticlesIndexRoute,TopicsSlugIndexRoute: TopicsSlugIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)